import React from "react";
import companyInfo from "../data/companyInfo";

const variantClass = {
  light: "btn btn-bizmak-outline-light btn-lg text-uppercase",
  "teal-outline": "btn btn-bizmak-teal-outline btn-lg text-uppercase",
  primary: "btn btn-primary btn-lg px-4 text-uppercase",
  gold: "btn btn-bizmak-gold btn-lg text-uppercase",
};

function OpenPDFButton({ variant = "primary" }) {
  return (
    <a
      className={variantClass[variant] || variantClass.primary}
      href={companyInfo.federal.capabilityStatementUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      View capability statement
    </a>
  );
}

export default OpenPDFButton;
